export interface SectionHeadingProps {
  heading: string;
  subHeading?: string;
  className?: string;
  variant?: 'sm' | 'xl';
}

const styleVariants: Record<
  'sm' | 'xl',
  Record<'headingClassName' | 'subHeadingClassName', string>
> = {
  sm: {
    headingClassName: 'text-lg font-semibold',
    subHeadingClassName: 'text-sm text-gray-500',
  },
  xl: {
    headingClassName: 'text-2xl',
    subHeadingClassName: 'mt-1 text-xs text-slate-400',
  },
};

export function SectionHeading({
  heading,
  subHeading,
  className,
  variant = 'xl',
}: SectionHeadingProps) {
  const { headingClassName, subHeadingClassName } = styleVariants[variant];
  return (
    <div className={`${variant === 'xl' ? 'mb-4' : ''} ${className ?? ''}`}>
      <div className={headingClassName}>{heading}</div>
      {subHeading && <div className={subHeadingClassName}>{subHeading}</div>}
    </div>
  );
}
